module.exports = __webpack_public_path__ + "img/dropped-image-7.f434c6f9.png";